export const menu = [
    {
        title: "Home",
        icon: "HiOutlineHome",
        path: "/"
    },

    {
        title: "Catalog",
        icon: "HiOutlineLibrary",
        // path: "dashboard/enrolled-courses"
    },

    {
        title: "About Us",
        icon: "HiOutlineUsers",
        path: "/about"
    },

    {
        title: "Contact Us",
        icon: "HiOutlineMail",
        path: "/enquiry"
    },
]

export const studentMenu = [
    {
        title: "My Profile",
        icon: "HiOutlineUserCircle",
        path: "dashboard/profile"
    },

    {
        title: "Courses",
        icon: "HiOutlineAcademicCap",
        path: "dashboard/enrolled-courses"
    },

    {
        title: "Cart",
        icon: "HiOutlineShoppingCart",
        path: "dashboard/cart"
    },

    {
        title: "Setting",
        icon: "HiOutlineCog",
        path: "dashboard/settings"
    },
]

export const instructorMenu = [
    {
        title: "My Profile",
        icon: "HiOutlineUserCircle",
        path: "dashboard/profile"
    },

    {
        title: "Dashboard",
        icon: "HiOutlineChartSquareBar",
        path: "/dashboard"
    },

    {
        title: "My Courses",
        icon: "HiOutlineBookOpen",
        path: "dashboard/my-courses"
    },

    {
        title: "Add Course",
        icon: "HiOutlinePlusCircle",
        path: "dashboard/add-course"
    },

    {
        title: "Setting",
        icon: "HiOutlineCog",
        path: "dashboard/settings"
    },
]